import { AssignRolesQueryDocument } from "@pathwright/graphql-client/src/generated"

const ASSIGN_ROLES_QUERY = AssignRolesQueryDocument

export default ASSIGN_ROLES_QUERY
